import { initCloudflareInterceptor } from './utils/cloudflareInterceptor'

initCloudflareInterceptor()

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Antd from 'ant-design-vue'
import App from './App.vue'
import router, { setupRouterGuards } from './router'
import i18n from './plugins/i18n'
import { useAppStore } from './store/app'
import 'ant-design-vue/dist/reset.css'
import './styles/index.less'

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
app.use(router)
app.use(i18n)
app.use(Antd)

setupRouterGuards(router)

const appStore = useAppStore(pinia)

Promise.all([appStore.initLangs()]).finally(() => {
  console.log('main.js =>',appStore.$state.lang)
  router.isReady().then(() => {
    app.mount('#app')
  })
})
